require('./dist/angular-ui-tree');
module.exports = 'ui.tree';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-tree/index.js
// module id = 589
// module chunks = 1